import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { ConfigService } from './config.service';
import { Observable } from 'rxjs';
import { ApiCacheService } from './api-cache.service';

@Injectable({
  providedIn: 'root',
})
export class ApiService {

  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private apiCacheService: ApiCacheService,
  ) {
  }

  get(service: string, url: string, params: any = {}, options?: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    observe?: 'body' | 'events' | 'response',
    withCredentials?: boolean,
  }, cache = false): Observable<any> {

    const apiUrl = this.configService.getApiUrl(service, url);

    const filteredParams = params ? Object.fromEntries(
      Object.entries(params).filter(([_, value]) => value !== undefined && value !== null)
    ) : {};

    const $params = new HttpParams({ fromObject: filteredParams as Record<string, string> });

    if (cache) {
      const cacheKey = this.apiCacheService.generateCacheKey(url, params);

      return this.apiCacheService.cacheRequest(cacheKey, () => 
        this.http.get<any>(apiUrl, {
          params: $params,
          responseType: options?.responseType as any,
          withCredentials: options?.withCredentials,
          observe: options?.observe as any,
        }),
      );
    } else {
      return this.http.get<any>(apiUrl, {
        params: $params,
        responseType: options?.responseType as any,
        withCredentials: options?.withCredentials,
        observe: options?.observe as any,
      });
    }
  }

  post(service: string, url: string, body: any = {}, options?: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    observe?: 'body' | 'events' | 'response',
    withCredentials?: boolean,
  }): Observable<any> {

    const apiUrl = this.configService.getApiUrl(service, url);

    return this.http.post<any>(apiUrl, body, {
      responseType: options?.responseType as any,
      withCredentials: options?.withCredentials,
      observe: options?.observe as any,
    });
  }

  patch(service: string, url: string, body: any = {}, options?: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    observe?: 'body' | 'events' | 'response',
    withCredentials?: boolean,
  }): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.http.patch<any>(apiUrl, body, {
      responseType: options?.responseType as any,
      withCredentials: options?.withCredentials,
      observe: options?.observe as any,
    });
  }

  put(service: string, url: string, body: any = {}, options?: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    observe?: 'body' | 'events' | 'response',
    withCredentials?: boolean,
  }): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.http.put<any>(apiUrl, body, {
      responseType: options?.responseType as any,
      withCredentials: options?.withCredentials,
      observe: options?.observe as any,
    });
  };

  delete(service: string, url: string, options?: {
    responseType?: 'arraybuffer' | 'blob' | 'json' | 'text',
    observe?: 'body' | 'events' | 'response',
    withCredentials?: boolean,
  }): Observable<any> {
    const apiUrl = this.configService.getApiUrl(service, url);

    return this.http.delete<any>(apiUrl, {
      responseType: options?.responseType as any,
      withCredentials: options?.withCredentials,
      observe: options?.observe as any,
    });
  }
}
